/*!
 * @license: MIT
 * Copyright (c) 2020 Shanord Inc.
 * https://shanord.com
 */
import {Accordion} from '@components/Accordion';
import {AnchorScroll} from '@components/AnchorScroll';
import {Body} from '@components/Body';
import {CategoryCollapse} from '@components/CategoryCollapse';
import {Collapse} from '@components/Collapse';
import {ContactForm} from '@components/ContactForm';
import {Environment} from '@components/Environment';
import {Filter} from '@components/Filter';
import FirstView from '@components/FirstView';
import {HamburgerButton} from '@components/HamburgerButton';
import {Header} from '@components/Header';
import {HeaderNav} from '@components/HeaderNav';
import {HeaderSm} from '@components/HeaderSm';
import {Hover} from '@components/Hover';
import {ImageSwiper} from '@components/ImageSwiper';
import {InterviewsDialog} from '@components/InterviewsDialog';
import {Kv} from '@components/Kv';
import {KvButton} from '@components/KvButton';
import {KvSlider} from '@components/KvSlider';
import {LogoSm} from '@components/LogoSm';
import {MailLink} from '@components/MailLink';
import {Nav} from '@components/Nav';
import {NavItem} from '@components/NavItem';
import {NewsMore} from '@components/NewsMore';
import {PageIndicator} from '@components/PageIndicator';
import {PreloadImage} from '@components/PreloadImage';
import {ProgramMore} from '@components/ProgramMore';
import {ProgramTag} from '@components/ProgramTag';
import {Scroll} from '@components/Scroll';
import {Sticky} from '@components/Sticky';
import {HorizontalSwiper} from '@components/Swiper';
import {Video} from '@components/Video';
import {ViewportAnimation} from '@components/ViewportAnimation';
import {WindowHeight} from '@components/WindowHeight';
import {WondersFamily} from '@components/WondersFamily';
import {createApplicationInitializer} from '@services/ApplicationInitializer';

/* eslint-disable sort-keys */
const appInitializer = createApplicationInitializer({
  '.js-page-indicator': PageIndicator,
  '.js-kv': Kv,
  '.js-kv-slider': KvSlider,
  '.js-header': Header,
  '.js-header-sm': HeaderSm,
  '.js-header-nav': HeaderNav,
  '.js-logo-sm': LogoSm,
  '.js-scroll': Scroll,
  '.js-mail-link': MailLink,
  '.js-nav': Nav,
  '.js-nav-item': NavItem,
  '.js-kv-button': KvButton,
  '.js-form': ContactForm,
  '.js-viewport': ViewportAnimation,
  '.js-preload-image': PreloadImage,
  '.js-video': Video,
  '.js-sticky': Sticky,
  '.js-first-view': FirstView,
  '.js-hamburger-button': HamburgerButton,
  '.js-collapse': Collapse,
  '.js-accordion': Accordion,
  '.js-window-height': WindowHeight,
  '.js-hover': Hover,
  '.js-swiper': HorizontalSwiper,
  '.js-environment': Environment,
  '.js-wonders-family': WondersFamily,
  '.js-interviews-dialog': InterviewsDialog,
  '.js-program-tag': ProgramTag,
  '.js-program-more': ProgramMore,
  '.js-image-swiper': ImageSwiper,
  '.js-category-collapse': CategoryCollapse,
  '.js-news-more': NewsMore,
  '.js-filter': Filter,
  body: Body,
  'a[href^="#"]': AnchorScroll,
});
/* eslint-enable sort-keys */

appInitializer.init();
